import React from 'react';
import {observer} from 'mobx-react';
import {EmployeeNameWithAvatar, Tag} from 'components';
import {FormattedMessage} from 'react-intl';

const EmployeeName = observer(({model, match, backPath}) => {
  const reviewee = model;
  const to = `/reviews/${match.params.cycleId}/reviewee/${reviewee.id}/employee/${reviewee.employee.id}/${reviewee.employee.urlSlug}/${backPath}`; 

  return (
    <div className='flex align-items-middle'>
      <EmployeeNameWithAvatar to={to} employee={model.employee}/>
      {model.scheduled && <Tag colour='waterloo' className='ml1'>
        <FormattedMessage id='performance_reviews.view.Scheduled'/>
      </Tag>}
    </div>
  );
});

export default EmployeeName;
